import type { AxiosInstance } from 'axios'

import type { User } from '@/types'

export default class AuthService {
  constructor(private readonly client: AxiosInstance) {}

  async get(): Promise<User> {
    const { data } = await this.client.get<User>('/auth/me', {
      params: { workspace: true },
    })
    return data
  }
}
